var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#F4F5FB"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2043B5",
    fillRule: "nonzero",
    d: "M67 39.31c-1.25.57-2.6.95-4 1.12a7.07 7.07 0 003.06-3.91c-1.35.8-2.84 1.4-4.43 1.71a6.92 6.92 0 00-5.1-2.23 7.05 7.05 0 00-6.79 8.68c-5.8-.3-10.93-3.11-14.37-7.39a7.14 7.14 0 002.15 9.44 6.87 6.87 0 01-3.15-.88 7.05 7.05 0 005.6 7.02 6.9 6.9 0 01-3.16.12 7 7 0 006.52 4.9A13.9 13.9 0 0133 60.83C36.09 62.83 39.76 64 43.7 64c12.94 0 20.26-11.08 19.82-21.03A14.3 14.3 0 0067 39.31z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.bd6ebc6f.svg";
export { ForwardRef as ReactComponent };